import { createTheme, type MantineTheme, TextInput } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

import { inputStyles, themedMantineInput } from './Input';

export const ThemedMantineTextInput: PartialDeep<MantineTheme> = createTheme({
  components: {
    TextInput: TextInput.extend({
      styles: (theme, params) => {
        if (params.variant === 'unstyled') return {};

        return themedMantineInput(theme);
      },
      classNames: (theme, params) => {
        if (params.variant === 'unstyled') return {};

        return { input: inputStyles.input(theme) };
      },
    }),
  },
});
